import { UserRole, UserRoleName } from './role.enum';

export class Roles {
  public static SUPER_ADMIN = 'Super Admin';

  public static SOURCE_SITE_ROLES: string[] = [
    UserRole.SuperAdmin,
    UserRole.SiteUser,
    UserRole.SourceSiteUser,
    UserRole.SourceSiteAdmin,
    UserRole.SourceSiteSuperAdmin
  ];

  public static SOURCE_SITE_ADMINS: string[] = [UserRole.SuperAdmin, UserRole.SourceSiteAdmin, UserRole.SourceSiteSuperAdmin];

  public static FILL_SITE_ROLES: string[] = [UserRole.ReceivingSiteSuperAdmin, UserRole.ReceivingSiteAdmin, UserRole.ReceivingSiteUser];

  public static FILL_SITE_ADMINS: string[] = [UserRole.SuperAdmin, UserRole.ReceivingSiteAdmin, UserRole.ReceivingSiteSuperAdmin];

  public static QP_ROLES: string[] = [
    UserRole.QualifiedPerson,
    UserRole.QualifiedPersonSuperAdmin,
    UserRole.QualifiedPersonAdmin,
    UserRole.QualifiedPersonSiteUser
  ];
  public static QP_ADMINS: string[] = [UserRole.QualifiedPersonSuperAdmin, UserRole.QualifiedPersonAdmin];

  public static SUPER_ADMIN_ROLES: string[] = [UserRole.SuperAdmin, UserRole.SourceSiteSuperAdmin, UserRole.ReceivingSiteSuperAdmin];
  public static ADMIN_ROLES: string[] = [
    UserRole.SuperAdmin,
    UserRole.SourceSiteSuperAdmin,
    UserRole.SourceSiteAdmin,
    UserRole.ReceivingSiteSuperAdmin,
    UserRole.ReceivingSiteAdmin,
    UserRole.QualifiedPersonSuperAdmin,
    UserRole.QualifiedPersonAdmin
  ];
  public static PATHMANAGER_ROLES: string[] = [
    UserRole.PATHManager
  ]
  public static SUPER_ADMIN_ROLENAMES: string[] = [UserRoleName.ReceivingSiteSuperAdmin, UserRoleName.SourceSiteSuperAdmin];
}
